/**
 * @fileoverview Modern theme.
 * Same colours as classic, but single coloured border.
 */

'use strict'
const defaultBlockStyles = {
  //事件
  event_blocks: {
    colourPrimary: '#2257bf',
    colourSecondary: '#5d93ff',
    colourTertiary: '#5d93ff',
  },
  //控制
  loop_blocks: {
    colourPrimary: '#00cadc',
    colourSecondary: '#3aefff',
    colourTertiary: '#3aefff',
  },
  // //逻辑
  logic_blocks: {
    colourPrimary: '#00cadc',
    colourSecondary: '#3aefff',
    colourTertiary: '#3aefff',
  },
  //运算
  math_blocks: {
    colourPrimary: '#F6438B',
    colourSecondary: '#F6438B',
    colourTertiary: '#F6438B',
  },
  // 文本-字符串
  text_blocks: {
    colourPrimary: '#64E44A',
    colourSecondary: '#64E44A',
    colourTertiary: '#64E44A',
  },
  // 列表
  list_blocks: {
    colourPrimary: '#FD603B',
    colourSecondary: '#FD603B',
    colourTertiary: '#FD603B',
  },
  // 字典
  dict_blocks: {
    colourPrimary: '#EFDD36',
    colourSecondary: '#EFDD36',
    colourTertiary: '#EFDD36',
  },
  //变量
  variable_blocks: {
    colourPrimary: '#E5D228',
    colourSecondary: '#E5D228',
    colourTertiary: '#E5D228',
  },
  // variable_dynamic_blocks: {
  //   colourPrimary: '#ccb800',
  //   colourSecondary: '#ffed4c',
  //   colourTertiary: '#ffed4c',
  // },
  // 函数
  procedure_blocks: {
    colourPrimary: '#EC861F',
    colourSecondary: '#EC861F',
    colourTertiary: '#EC861F',
  },
  // 媒体
  media_blocks: {
    colourPrimary: '#CA53FB',
    colourSecondary: '#CA53FB',
    colourTertiary: '#CA53FB',
  },
  //海龟动作
  hat_blocks: {
    colourPrimary: '#FF9C38',
    colourSecondary: '#FF9C38',
    colourTertiary: '#FF9C38',
    hat: 'cap',
  },
  //画笔控制
  turtle_control_blocks: {
    colourPrimary: '#1de83f',
    colourSecondary: '#1de83f',
    colourTertiary: '#1de83f',
    hat: 'cap',
  },
  //海龟状态
  turtle_status_blocks: {
    colourPrimary: '#a8cd27',
    colourSecondary: '#a8cd27',
    colourTertiary: '#a8cd27',
    hat: 'cap',
  },
  //海龟窗口
  turtle_screen_blocks: {
    colourPrimary: '#eca110',
    colourSecondary: '#eca110',
    colourTertiary: '#eca110',
    hat: 'cap',
  },
  // // 绘图
  // colour_blocks: {
  //   colourPrimary: '#523acc',
  //   colourSecondary: '#9181ff',
  //   colourTertiary: '#9181ff',
  // },

  // 数据库返回的积木
  //  我的模型
  my_model_blocks: {
    colourPrimary: '#F44141',
    colourSecondary: '#F44141',
    colourTertiary: '#F44141',
  },
  // 实训模型
  training_model_blocks: {
    colourPrimary: '#2EE6D4',
    colourSecondary: '#2EE6D4',
    colourTertiary: '#2EE6D4',
  },
  // 公共模型
  public_model_blocks: {
    colourPrimary: '#2bd6a8',
    colourSecondary: '#2bd6a8',
    colourTertiary: '#2bd6a8',
  },
  //基础模型
  basic_model_blocks: {
    colourPrimary: '#AED42B',
    colourSecondary: '#AED42B',
    colourTertiary: '#AED42B',
  },
  //进阶模型
  advanced_model_blocks: {
    colourPrimary: '#19C17D',
    colourSecondary: '#19C17D',
    colourTertiary: '#19C17D',
  },
  //智能硬件
  Intelligent_hardware_blocks: {
    colourPrimary: '#54ADF1',
    colourSecondary: '#54ADF1',
    colourTertiary: '#54ADF1',
  },
  // 新建积木
  custom_blocks: {
    colourPrimary: '#9A8DEE',
    colourSecondary: '#9A8DEE',
    colourTertiary: '#9A8DEE',
  },
  // 行驶积木
  drive_blocks: {
    colourPrimary: '#7765f4',
    colourSecondary: '#7765f4',
    colourTertiary: '#7765f4',
  },
  // 灯光积木
  light_blocks: {
    colourPrimary: '#FF9C38',
    colourSecondary: '#FF9C38',
    colourTertiary: '#FF9C38',
  },
  // 姿势积木
  posture_blocks: {
    colourPrimary: '#A9CE28',
    colourSecondary: '#A9CE28',
    colourTertiary: '#A9CE28',
  },
  // 声音积木
  voice_blocks: {
    colourPrimary: '#1AD0E0',
    colourSecondary: '#1AD0E0',
    colourTertiary: '#1AD0E0',
  },
  // 情感积木
  emotion_blocks: {
    colourPrimary: '#F46267',
    colourSecondary: '#F46267',
    colourTertiary: '#F46267',
  },
  // 检测积木
  detect_blocks: {
    colourPrimary: '#AFD52C',
    colourSecondary: '#AFD52C',
    colourTertiary: '#AFD52C',
  },
  // 小聪机器人-显示积木
  robot_print: {
    colourPrimary: '#ef910a',
    colourSecondary: '#ef910a',
    colourTertiary: '#ef910a',
  },
  //  小智机器人-摄像头积木
  robot_B_camera: {
    colourPrimary: '#ef8791',
    colourSecondary: '#ef8791',
    colourTertiary: '#ef8791',
  },
  //  小智机器人-技能积木
  robot_B_skill: {
    colourPrimary: '#28f2ff',
    colourSecondary: '#28f2ff',
    colourTertiary: '#28f2ff',
  },
}

//以下样式暂时没用处
const categoryStyles = {
  event_blocks: {
    colour: '#a5745b',
  },
  colour_category: {
    colour: '#aa23e2',
    // colour: "#a5745b"
  },
  list_category: {
    colour: '#745ba5',
  },
  logic_category: {
    colour: '#5b80a5',
  },
  loop_category: {
    colour: '#5ba55b',
  },
  math_category: {
    colour: '#14c62d',
    // colour: "#5b67a5"
  },
  procedure_category: {
    colour: '#995ba5',
  },
  text_category: {
    colour: '#5ba58c',
  },
  variable_category: {
    colour: '#ccb800',
    // colour: "#a55b99"
  },
  variable_dynamic_category: {
    colour: '#ccb800',
    // colour: "#a55b99"
  },
  // 媒体
  media_category: {
    colour: '#ce57ff',
  },
}

export default {
  defaultBlockStyles,
  categoryStyles,
}
